import { DesignSystemProvider } from '@acceso/design-system';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode } from 'react';

import { Notifications } from '@/features/app/components/Notifications/Notifications';
import { queryClient } from '@/lib/react-query';

export interface RootProviderProps {
  children: ReactNode;
}

export function RootProvider({ children }: RootProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <DesignSystemProvider>
        <Notifications />
        {children}
      </DesignSystemProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
